import type { TextInputProps } from '@hover/blueprint';
import React, { useState } from 'react';
import { config, useTransition } from 'react-spring';

import { useIsInitialRender } from 'src/shared/hooks';

import { PasswordInput } from '../PasswordInput';

type RevealablePasswordInputProps = TextInputProps;

const PERSPECTIVE = 'perspective(40rem)';

const RevealablePasswordInput = (props: RevealablePasswordInputProps) => {
  const [isVisible, beVisible] = useState(false);
  const isInitialRender = useIsInitialRender();

  const transitions = useTransition(!isVisible, {
    config: config.stiff,
    immediate: isInitialRender,
    initial: { opacity: 1 },
    from: {
      opacity: 0,
      transform: `${PERSPECTIVE} rotateX(${isVisible ? '-' : ''}180deg)`,
    },
    enter: {
      transform: `${PERSPECTIVE} rotateX(0deg)`,
      opacity: 1,
      position: 'relative',
      width: '100%',
    },
    leave: {
      transform: `${PERSPECTIVE} rotateX(${isVisible ? '' : '-'}180deg)`,
      opacity: 0,
      position: 'absolute',
      width: '100%',
    },
  });

  const onToggle = () => beVisible(!isVisible);

  return (
    <>
      {transitions((style, item) =>
        item ? (
          <PasswordInput {...props} locked onToggle={onToggle} style={style} />
        ) : (
          <PasswordInput {...props} onToggle={onToggle} style={style} />
        ),
      )}
    </>
  );
};

export { RevealablePasswordInput };
